import { render, staticRenderFns } from "./SolicitudInformacionVisualizar.vue?vue&type=template&id=af9b4b72&scoped=true&lang=pug&"
import script from "./SolicitudInformacionVisualizar.vue?vue&type=script&lang=js&"
export * from "./SolicitudInformacionVisualizar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9b4b72",
  null
  
)

export default component.exports